// extracted by mini-css-extract-plugin
export default {"items":"Theme_items__3yGNr","image":"Theme_image__CiFCC","name":"Theme_name__EgmWG","button":"Theme_button__LdG+6","selected":"Theme_selected__+xN3B"};